import React from 'react';
import DefaultSimManuelRecipient from '../components/ManulRecipient/DefaultSimManuelRecipient';
import { phone_number } from '../utils/DictionaryManagementUtils';

//= ========================================================================

const Sim_B05_SendMoneyToPhoneManually = ({
  globJSON,
  selectedScreen,
  language,
  simPlatform,
  slideshowRefs = null,
}) => (
  <DefaultSimManuelRecipient
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    language={language}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
    manualName={phone_number}
  />
);

export default Sim_B05_SendMoneyToPhoneManually;
